export const options = [
  {
    value: "Standard",
    label: "Standard",
    description: "1.5 hours hours, as 2 x 45 minutes or 3 x 30 interatice sets",
  },
  {
    value: "Extra",
    label: "Extra",
    description: "Extra party set of 30 minutes",
  },
  {
    value: "Aperitivo",
    label: "Aperitivo",
    description: "1 hour aperitivo set",
  },
];
